"use client"

import { Button } from "@/components/ui/button"
import { AlertTriangle, CheckCircle } from "lucide-react"

interface PaymentConfirmationModalProps {
    selectedCount: number
    onConfirm: () => void
    onCancel: () => void
    isLoading?: boolean
}

export function PaymentConfirmationModal({
    selectedCount,
    onConfirm,
    onCancel,
    isLoading = false,
}: PaymentConfirmationModalProps) {
    return (
        <div className="bg-background w-full flex flex-col overflow-hidden rounded-lg shadow-lg border">
            <div className="space-y-6 p-6">
                <div className="flex items-start gap-4">
                    <div className="flex-1 space-y-4">
                        <div className="space-y-2">
                            <h3 className="text-xl font-semibold text-foreground leading-tight">
                                Confirmar pagamento
                            </h3>
                            <p className="text-muted-foreground leading-relaxed">
                                Você está prestes a marcar{" "}
                                <span className="text-foreground bg-muted px-2 py-0.5 rounded-md">
                                    {selectedCount} {selectedCount !== 1 ? "itens" : "item"}
                                </span>{" "}
                                como pago{selectedCount !== 1 ? "s" : ""}.
                            </p>
                        </div>

                        <div className="bg-gradient-to-r from-amber-50 to-orange-50 border border-amber-200 rounded-xl p-4 shadow-sm">
                            <div className="flex items-start gap-3">
                                <div className="w-6 h-6 rounded-full bg-amber-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                                    <AlertTriangle className="w-4 h-4 text-amber-600" />
                                </div>
                                <div className="space-y-2">
                                    <p className="text-sm font-semibold text-amber-900 leading-tight">
                                        Atenção: Esta ação será auditada
                                    </p>
                                    <p className="text-xs text-amber-800 leading-relaxed">
                                        Todas as alterações de status de pagamento são registradas e podem ser rastreadas para fins de
                                        auditoria.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="flex gap-3 p-6 pt-0">
                <Button
                    variant="outline"
                    onClick={onCancel}
                    disabled={isLoading}
                    className="flex-1"
                >
                    Cancelar
                </Button>
                <Button
                    onClick={onConfirm}
                    disabled={isLoading}
                    className="flex-1"
                >
                    <CheckCircle className="w-4 h-4 mr-2" />
                    {isLoading ? "Processando..." : "Confirmar pagamento"}
                </Button>
            </div>
        </div>
    )
}
